export default __webpack_public_path__ + "static/media/Q8-2.0843d19a.jpg";